import type { AdministrationContentPage } from "@kontextwerk/control-web-frame/components/administration"

export const pageConfig: AdministrationContentPage = {
  id: "phone",
  title: "Telefonvorlagen",
  path: "phone",
  tabs: [
    ["outbound", "Ausgehend"],
    ["inbound", "Eingehend"],
  ].map(([purpose, title]) => ({
    id: `phone-${purpose}`,
    title,
    routeSegment: purpose.replaceAll("_", "-"),
    widthType: "normal",
    testId: `controlAdmin.organizationView.announcementTemplates.phone.${purpose}`,
  })),
}
